import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setPlacingMoneySource } from '../../../../actions/publishTerms';
import { loadPublishTerms } from '../../../../thunks/publishTerms/loadPublishTerms';

import { getOptions } from './utils';
import { MoneySource } from './MoneySource';
import { EMoneySource } from '../../../../types/reducers/user';
import { selectAvailableMoneySources, selectPlacingMoneySource } from '../../../../reducers/v2/moneySources/selectors';
import { selectIsSubagent } from '../../../../selectors/user';

export const MoneySourceContainer = () => {
  const dispatch = useDispatch();
  const moneySource = useSelector(selectPlacingMoneySource);
  const availableMoneySources = useSelector(selectAvailableMoneySources);
  const isSubAgent = useSelector(selectIsSubagent);
  const options = getOptions(availableMoneySources);

  const handleChange = React.useCallback(
    (value: EMoneySource) => {
      dispatch(setPlacingMoneySource(value));
      dispatch(loadPublishTerms());
    },
    [dispatch],
  );

  if (!isSubAgent) {
    return null;
  }

  return <MoneySource value={moneySource || ''} options={options} handleChange={handleChange} />;
};
